import React from "react";
import Grid from "@mui/material/Grid";
//icons
import AppleIcon from "@mui/icons-material/Apple";
import { IoLogoGooglePlaystore } from "react-icons/io5";
//styles
import "./Footer.scss";
import { Link } from "react-router-dom";
import language from "../../../language";
const Footer = () => {
  let languageSelectedEnglish =
    sessionStorage.getItem("language") === "english" ||
      !sessionStorage.getItem("language")
      ? true
      : false;
  return (
    <>
      {/* Desktop */}
      <Grid container className="FooterWrapper">
        <Grid
          container
          xl={9}
          lg={9}
          md={10}
          sm={11}
          xs={11}
          className="FooterSubWrap"
        >
          <Grid
            item
            xl={4}
            lg={4}
            md={4}
            sm={4}
            xs={12}
            className="LinksWrapper"
          >
            <p className="Header">
              {languageSelectedEnglish ? "Company" : language.company}
            </p>
            <Grid item className="LinksNav">
              <Link
                to="/"
                style={{ textDecoration: "none", color: "#0c2f54" }}
              >
                <p className="LinksFooter">
                  {" "}
                  {languageSelectedEnglish ? "Home" : language.aboutUs}
                </p>
              </Link>
              <Link
                to="/client/contact-us"
                style={{ textDecoration: "none", color: "#0c2f54" }}
              >
                <p className="LinksFooter">
                  {" "}
                  {languageSelectedEnglish ? "Contact Us" : language.aboutUs}
                </p>
              </Link>
            </Grid>
          </Grid>
          <Grid
            item
            xl={4}
            lg={4}
            md={4}
            sm={4}
            xs={12}
            className="LinksWrapper"
          >
            <p className="Header">
              {languageSelectedEnglish ? "About" : language.about}
            </p>
            <Grid item className="LinksNav">
              <Link
                to="/client/about-us"
                style={{ textDecoration: "none", color: "#0c2f54" }}
              >
                <p className="LinksFooter">
                  {" "}
                  {languageSelectedEnglish ? "About Us" : language.aboutUs}
                </p>
              </Link>
            </Grid>
          </Grid>
          <Grid
            item
            xl={4}
            lg={4}
            md={4}
            sm={4}
            xs={12}
            className="LinksWrapper"
          >
            <p className="Header">
              {languageSelectedEnglish ? "Information" : language.Information}
            </p>
            <Grid item className="LinksNav">
              <Link
                to="/client/terms-and-policy"
                style={{ textDecoration: "none", color: "#0c2f54" }}
              >
                <p className="LinksFooter">
                  {languageSelectedEnglish
                    ? "Terms & Conditions"
                    : language.termsConditions}
                </p>
              </Link>
              <Link
                to="/client/privacy-policy"
                style={{ textDecoration: "none", color: "#0c2f54" }}
              >
                <p className="LinksFooter">
                  {languageSelectedEnglish
                    ? "Privacy Policy"
                    : language.privacyPolicy}
                </p>
              </Link>

              <Link
                to="/client/cookie-policy"
                style={{ textDecoration: "none", color: "#0c2f54" }}
              >
                <p className="LinksFooter">
                  Cookie-Policy
                </p>
              </Link>

              <Link
                to="/client/faqs"
                style={{ textDecoration: "none", color: "#0c2f54" }}
              >
                <p className="LinksFooter">
                  FAQs
                </p>
              </Link>
            </Grid>
          </Grid>
        </Grid>
        <Grid align="center" item xs={12} className="">
          {/* <div className="Header" >We accept</div> */}
          <p className="weAccept">We accept</p>
          <div className="visacardsOuter">
            <div className="visaMain">
              <img src={require('../../assets/visa.png')} style={{ width: "100px" }} alt="" />
              <div className="visaText">VISA</div>
            </div>
            <div className="visaMain">
              <img src={require('../../assets/masterCard.png')} style={{ width: "90px" }} alt="" />
              <div className="visaText">MASTERCARD</div>
            </div>
            <div className="visaMain">
              <img src={require('../../assets/americanExpress.png')} style={{ height: "70px" }} alt="" />
              <div className="visaText">AMERICAN EXPRESS</div>
            </div>
            <div className="visaMain">
              <img src={require('../../assets/samsungpay.png')} style={{ height: "70px" }} alt="" />
              <div className="visaText">SAMSUNG PAY</div>
            </div>
            <div className="visaMain">
              <img src={require('../../assets/Apple_Pay.png')} style={{ width: "100px" }} alt="" />
              <div className="visaText">APPLE PAY</div>
            </div>
            <div className="visaMain">
              <img src={require('../../assets/Gpay.png')} style={{ width: "100px" }} alt="" />
              <div className="visaText">GOOGLE PAY</div>
            </div>

          </div>
        </Grid>
        <Grid align="center" item xs={12} className="horizontalLineWrapper">
          <div className="HorizontalLine" />
        </Grid>
        <Grid container xs={12} className="buttonContainer">
          <Grid item xs={12} className="label" align="center">
            <p className="footerLabel">© 2025 Bus Arabia</p>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default Footer;
